import React from "react";
import getSymbolFromCurrency from "currency-symbol-map";

import Tooltip from "components/Tooltip";

import styles from "./ProviderCurrenciesCell.module.scss";

interface Props {
  currencies?: string | null;
}

const VISIBLE_CURRENCIES = 4;

const ProviderCurrenciesCell: React.FC<Props> = ({ currencies }) => {
  const currencyList = (currencies ?? "")
    .split(",")
    .map((currency) => currency.trim())
    .filter(Boolean);

  if (currencyList.length === 0) return <>-</>;

  const visibleCurrencies = currencyList.slice(0, VISIBLE_CURRENCIES);
  const hiddenCurrencies = currencyList.slice(VISIBLE_CURRENCIES);
  const formatCurrency = (currency: string) =>
    `${getSymbolFromCurrency(currency) ?? ""} ${currency}`.trim();

  return (
    <div className={styles.currencies}>
      {visibleCurrencies.map((currency) => (
        <span className={styles.currency} key={currency}>
          {formatCurrency(currency)}
        </span>
      ))}
      {hiddenCurrencies.length > 0 && (
        <Tooltip text={hiddenCurrencies.map(formatCurrency).join(", ")} asChild>
          <button
            className={styles.more}
            type="button"
            aria-label={`Show ${hiddenCurrencies.length} more currencies`}
            onClick={(event) => event.stopPropagation()}
          >
            +{hiddenCurrencies.length}
          </button>
        </Tooltip>
      )}
    </div>
  );
};

export default ProviderCurrenciesCell;
